import axios from 'axios';

// Exporta los datos de woocommerce
export function getwoocommerce(route) {
  return axios.get(`${process.env.REACT_APP_URL_WEB}${route}`, {
    auth: {
      username: process.env.REACT_APP_USER_KEY,
      password: process.env.REACT_APP_SECRET_KEY,
    },
  })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      console.error(error);
      return [];
    });
}

// Exporta los datos de los usuarios
let dataUser = [];

export async function getUser(mail) {
  try {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/user/user?email=${mail}`);
    dataUser = response.data;
    return dataUser;
  } catch (error) {
    console.error('Error al obtener los datos del usuario:', error);
    return null;
  }
}

//registro de usuarios // Función para realizar el registro del usuario
export const registerUser = async (userData) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/user/register`, userData);
    return response.data;
  } catch (error) {
    throw new Error('Error registrando usuario:', error.message);
  }
};













export default {getUser, registerUser,getwoocommerce}

